<template>
  <!-- <el-container class="index-con">
    <el-header class="index-header">
      <navcon></navcon>
    </el-header>
    <el-container class="index-con">
      <el-aside :class="showclass">
        <leftnav></leftnav>
      </el-aside>
      <el-container class="main-con">
        <el-main clss="index-main">
          <router-view></router-view>
        </el-main>
      </el-container>
    </el-container>
  </el-container> -->

  <el-container class="index-con">
    <el-aside :class="showclass">
      <leftnav></leftnav>
    </el-aside>
    <el-container class="main-con">
      <el-header class="index-header">
        <navcon></navcon>
      </el-header>
      <el-main class="index-main">
        <div class="tb-view-shell">
          <div class="tb-grid-line tb-grid-line-x"></div>
          <div class="tb-grid-line tb-grid-line-y"></div>
          <router-view></router-view>
        </div>
      </el-main>
    </el-container>
  </el-container>
</template>
<script>
// 导入组件

import { getMemberFeedbackList,setMemberStatus } from '../api/userMG'


import navcon from '../components/navcon.vue'
import leftnav from '../components/leftnav.vue'
export default {
  name: 'index',
  data() {
    return {
      showclass: 'asideshow',
      showtype: false,
      total:0
    }
  },
  // 注册组件
  components: {
    navcon,
    leftnav
  },
  methods: {},
  created() {
    // 监听
    this.$root.Bus.$on('toggle', value => {
      if (value) {
        this.showclass = 'asideshow'
      } else {
        setTimeout(() => {
          this.showclass = 'aside'
        }, 300)
      }
    })

    




  },
  beforeUpdate() {},
  // 挂载前状态(里面是操作)
  beforeMount() {
    // 弹出登录成功
    this.$message({
      message: '登录成功',
      type: 'success'
    })
  }
}
</script>
<style >
.index-con {
  height: 100%;
  width: 100%;
  box-sizing: border-box;
  position: relative;
  overflow: hidden;
}
.index-con::before {
  content: '';
  position: absolute; inset: 0;
  background:
    radial-gradient(800px 500px at 0 0, rgba(64, 158, 255, 0.14), transparent 60%),
    radial-gradient(700px 500px at 100% 100%, rgba(79, 140, 255, 0.10), transparent 60%);
  pointer-events: none;
  z-index: 0;
}
.index-con > * { position: relative; z-index: 1; }

.aside, .asideshow {
  height: 100%;
  margin: 0px;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.98) 0%, rgba(245, 249, 255, 0.96) 100%) !important;
  border-right: 1px solid rgba(79, 140, 255, 0.14);
  box-shadow: 8px 0 34px rgba(37, 99, 235, 0.08), 0 0 20px rgba(37, 99, 235, 0.04);
  transition: width .3s ease, box-shadow .3s ease;
  position: relative;
  overflow: hidden;
}
.aside     { width: 76px !important; }
.asideshow { width: 256px !important; }
.aside::after, .asideshow::after {
  content: '';
  position: absolute;
  right: 0; top: 0; bottom: 0;
  width: 1px;
  background: linear-gradient(180deg, transparent, rgba(79, 140, 255, 0.45), transparent);
}
.aside::before, .asideshow::before {
  content: '';
  position: absolute;
  inset: 0;
  background:
    radial-gradient(220px 160px at 0 0, rgba(64, 158, 255, 0.10), transparent 60%),
    linear-gradient(180deg, rgba(255, 255, 255, 0.82), transparent 26%);
  pointer-events: none;
}

.index-header {
  padding: 0px !important;
  height: 72px !important;
  background: linear-gradient(90deg, rgba(255, 255, 255, 0.96), rgba(245, 249, 255, 0.9)) !important;
  border-bottom: 1px solid rgba(79, 140, 255, 0.14);
  backdrop-filter: blur(10px);
  box-shadow: 0 8px 28px rgba(37, 99, 235, 0.06), 0 0 18px rgba(64, 158, 255, 0.06);
}
.index-main {
  padding: 0px;
  animation: tb-fade-in .35s ease both;
  overflow: hidden;
}
.tb-view-shell {
  height: 100%;
  position: relative;
  padding: 18px;
  overflow: auto;
}
.tb-view-shell::before,
.tb-view-shell::after {
  content: '';
  position: absolute;
  pointer-events: none;
  z-index: 0;
}
.tb-view-shell::before {
  inset: 12px;
  border: 1px solid rgba(79, 140, 255, 0.08);
  border-radius: 22px;
  background:
    linear-gradient(180deg, rgba(255, 255, 255, 0.84), rgba(255, 255, 255, 0.52)),
    rgba(255, 255, 255, 0.42);
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.68);
}
.tb-view-shell::after {
  top: 36px;
  right: 48px;
  width: 180px;
  height: 180px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(64, 158, 255, 0.12), transparent 68%);
  filter: blur(12px);
}
.tb-view-shell > * {
  position: relative;
  z-index: 1;
}
.tb-grid-line {
  position: absolute;
  z-index: 0;
  pointer-events: none;
}
.tb-grid-line-x {
  left: 30px;
  right: 30px;
  top: 54px;
  height: 1px;
  background: linear-gradient(90deg, transparent, rgba(79, 140, 255, 0.18), transparent);
}
.tb-grid-line-y {
  top: 30px;
  bottom: 30px;
  right: 72px;
  width: 1px;
  background: linear-gradient(180deg, transparent, rgba(79, 140, 255, 0.12), transparent);
}
</style>



// WEBPACK FOOTER //
// src/views/index.vue